import React, { Fragment } from 'react';
import { Form, Select } from 'antd';
import transportFieldsConnect from '../../../common/hoc/transportFieldsConnect';
const BrandName = ({ form, disabled, brandsTypes, onChange }) => {
  const { getFieldDecorator } = form;
  const handleChange = val => {
    onChange(val);
    if (val && form.getFieldError('brand')) {
      form.setFieldsValue({ brand: val });
    }
  };
  return (
    <Fragment>
      <span className="label">Марка:</span>
      <Form.Item>
        {getFieldDecorator('brand', {
          rules: [{
            required: true,
            message: "Поле, обязательно для заполнения"
          }]
        })(
          <Select
            placeholder="Выберите марку"
            className="basicInput"
            disabled={disabled}
            onChange={handleChange}
            showSearch
            filterOption={(input, option) =>
              option.props.children
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
            }
            getPopupContainer={trigger => trigger.parentNode}
          >
            {brandsTypes &&
              brandsTypes.map((brand, index) => (
                <Select.Option value={brand.vehicleBrandId} key={index}>
                  {brand.brandName}
                </Select.Option>
              ))}
          </Select>
        )}
      </Form.Item>
    </Fragment>
  );
};

export default transportFieldsConnect(BrandName, ['brandsTypes']);
